import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../lib/i18n";
import api, { apiError } from "../lib/api";
import { Shell } from "./ForgotPassword";
import PasswordField from "../components/PasswordField";

export default function ChangePassword() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const { user, refresh } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setMsg("");
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      await refresh();
      if (user.role === "player") nav("/today");
      else if (user.role === "care_manager") nav("/care");
      else nav("/admin");
    } catch (err) { setMsg(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <Shell title={t("changePwTitle")} sub={t("changePwSub")}>
      <form onSubmit={submit} className="space-y-4" data-testid="change-pw-form">
        <PasswordField data-testid="change-current" autoComplete="current-password" enterKeyHint="next" placeholder={t("currentPassword")} value={cur} onChange={(e) => setCur(e.target.value)} required lang={lang} />
        <PasswordField data-testid="change-new" autoComplete="new-password" enterKeyHint="go" placeholder={t("newPassword")} value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} showRules lang={lang} />
        <button data-testid="change-submit" className="pc-btn pc-btn-primary w-full" disabled={loading}>{loading ? "…" : t("changePwCta")}</button>
      </form>
      {msg && <p data-testid="change-msg" className="mt-4 text-sm" style={{ color: "#ff8080" }}>{msg}</p>}
    </Shell>
  );
}
